import { render, staticRenderFns } from "./ChecklistGeneralKasbon.vue?vue&type=template&id=1a2f11e0"
import script from "./ChecklistGeneralKasbon.vue?vue&type=script&lang=js"
export * from "./ChecklistGeneralKasbon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports